// extracted by mini-css-extract-plugin
export default {"contentContainer":"TournamentMatchPage_contentContainer__Hrrer","playerWrapper":"TournamentMatchPage_playerWrapper__YrIq5"};